<script lang="ts">
    import { PropType } from "vue";

    export default {
        props: {
            variant: String as PropType<'primary' |'outline-dark'>
        },
        template: '#template-button',
    }
</script>
